import React from 'react';
import { PaperClipOutlined, PictureOutlined } from '@ant-design/icons';

const DragDropText = () => {
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(24, 144, 255, 0.1)',
        zIndex: 10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '2px dashed #1890ff',
        borderRadius: '4px',
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            fontSize: '24px',
            marginBottom: '8px',
          }}
        >
          <PaperClipOutlined style={{ marginRight: '8px' }} />
          <PictureOutlined />
        </div>
        <div style={{ fontWeight: 'bold' }}>Drop files here</div>
      </div>
    </div>
  );
};

export default DragDropText;
